import { styled } from '@mui/material/styles';
import { Tabs } from 'components/Tabs';

export const StyledSettingsTabs = styled(Tabs)({
  '&:not(.MuiTabs-vertical)': {
    margin: '0 -1.5rem 2rem',
  },
});
